import { getItem } from "./LocalStorage";

// "AUTO" | "L" | "hL"  — il select in UserCustomization arriverà dopo
export const getTankUnit = () => getItem("tankUnit") || "AUTO";

// Decide L vs hL: hL se preferenza esplicita, oppure AUTO + tank grande (>=10000)
export const formatTankUnit = (quantity, capacity, tankUnit = getTankUnit()) => {
  const q = Number(quantity) || 0;
  const c = Number(capacity) || 0;
  const useHL = tankUnit === "hL" || (tankUnit === "AUTO" && c >= 10000);
  return {
    displayedQuantity: useHL ? Math.round(q / 100) : Math.round(q),
    displayedCapacity: useHL ? Math.round(c / 100) : Math.round(c),
    unit: useHL ? "hL" : "L",
  };
};

export const tankOccupancy = (quantity, capacity) =>
  Number(capacity) > 0
    ? Math.round((Number(quantity) * 100) / Number(capacity))
    : 0;
